<script lang="ts" setup>
const props = defineProps<{ text?: string; dark?: boolean }>()
</script>

<template>
    <div
        v-html-gpp="props.text"
        class="text-neutral-secondary paragraph-md col-span-full text-center lg:col-span-10 lg:col-start-2"
        :class="{ dark }"
    />
</template>
